import DateFormat from "../../components/dateFormater/dateFormat1";

function DetailParticipantResume({ data }) {
  return (
    <>
      <div className="fw-400">
        <strong className="text-theme">{data.training.title}</strong>
        {` by ${data.institution.institutionName} (${data.instructor.namaInstructor})`}
      </div>
      <div className="small text-inverse text-opacity-50">{`${DateFormat(data.start)} - ${DateFormat(data.end)}`}</div>
      <div className="small text-inverse text-opacity-50 mb-2">{`Location: ${data.location.location}`}</div>
    </>
  );
}

export default DetailParticipantResume;
